import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from 'next-themes';
import classNames from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { Button, Loader } from '@/components/ui';
import { Variants } from '@/enums/button';
import { hooks as orderHooks } from '@/domains/esim/order';
import { EsimPaymentBannerStatus } from '@/enums/esim';

import QrBlock from '../Qr/Qr';
import SalesError from '../Modals/SalesError/SalesError';

import styles from './index.module.scss';

export const SuccessBanner = ({ data }) => {
  const { theme } = useTheme();
  const router = useRouter();
  const qrCodeRef = useRef(null);
  const checkWindow = typeof window !== 'undefined';

  const [salesError, setSalesError] = useState(false);
  const [dataBanner, setDataBanner] = useState();

  const trackId = checkWindow && localStorage.getItem('esimTID');
  const offerId = checkWindow && localStorage.getItem('planID');
  const customerPhone = checkWindow && localStorage.getItem('tel');
  const statusPrefix =
    router.query.paymentStatus === 'SUCCESS' ? 'success' : 'error';

  const [salesMutation, { isLoading: salesLoading }] =
    orderHooks.usePostSales();

  const handleScroll = () => {
    const section = document.getElementById(
      data?.[`${statusPrefix}_top_link_scroll_to`],
    );
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  useEffect(() => {
    if (router.query.paymentStatus === EsimPaymentBannerStatus.SUCCESS) {
      salesMutation({
        trackId,
        offerId,
      })
        .unwrap()
        .then((res) => {
          setDataBanner(res?.data);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'purchase',
          });
        })
        .catch((error) => {
          setSalesError(true);
        })
        .finally(() => {
          localStorage.removeItem('tel');
          localStorage.removeItem('esimTID');
          localStorage.removeItem('planID');
        });
    }
  }, [router.query]);

  if (salesLoading) {
    return <Loader fullScreen={true} />;
  }

  return (
    <>
      <div className='section' itemScope itemType='https://schema.org/Message'>
        <div className='wrapper'>
          <div className={classNames([styles.container])}>
            <Image
              src={`/assets/${
                theme === 'light' ? 'Shapes.png' : 'ShapesDark.png'
              }`}
              layout='fill'
              className={styles.img}
              alt='img'
              loading='lazy'
            />
            <Image
              src={`/assets/${
                theme === 'light' ? 'ShapesMobile.png' : 'ShapesMobileDark.png'
              }`}
              layout='fill'
              className={styles.mobileImg}
              alt='img'
              loading='lazy'
            />
            <div className={styles.content}>
              <h3 className={styles.title}>
                {data?.[`${statusPrefix}_title`]}
              </h3>
              <span onClick={handleScroll} className={styles.activate}>
                {data?.[`${statusPrefix}_top_link_text`]}
              </span>
              <div className={styles.yourNumber}>
                <span className={styles.text}>
                  {data?.[`${statusPrefix}_text_before_number`]}
                </span>
                <span className={classNames([styles.text__bold, styles.text])}>
                  {customerPhone}
                </span>
              </div>
              {dataBanner?.qrCode && (
                <div className={styles.qrBlock}>
                  <div className={styles.qr}>
                    <QrBlock
                      qrRef={qrCodeRef}
                      size={160}
                      qrCode={dataBanner?.qrCode}
                    />
                  </div>
                </div>
              )}
              <p className={styles.qrInfo}>
                {data?.[`${statusPrefix}_qr_description`]}
              </p>
              <Button
                Component='router'
                href={data?.[`${statusPrefix}_bottom_link_slug`]}
                variant={Variants.outline}
              >
                {data?.[`${statusPrefix}_bottom_link_text`]}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {salesError && (
        <SalesError
          active={salesError}
          setActive={() => setSalesError(!salesError)}
        />
      )}
    </>
  );
};
